import axios from "axios";

async function editCaption(url, caption) {
    const result = await axios("/api/editComment?url=" + url + "&comment=" + caption);
    console.log(result.data);
}

export default editCaption;
